import { OktaAuth } from '@okta/okta-auth-js';
import config from './config';

export default new OktaAuth({
    issuer: config.okta.issuer,
    clientId: config.okta.clientId,
    redirectUri: window.location.origin + '/redirect',
    postLogoutRedirectUri: window.location.origin + '/login',
});
